/* A product with more than one variant. The port's own script (the review files' products have one): choosing a variant
   opens the page on it, so the price, the stock and the buy bar are the store's own for that variant.
   Copied into assets by tools/build-assets.mjs. */
(function () {
  var pick = document.querySelector('[data-variant-pick]');
  if (!pick) return;
  pick.addEventListener('change', function () {
    var u = new URL(window.location.href);
    u.searchParams.set('variant', pick.value);
    window.location.replace(u.toString());
  });
})();
